import { useState } from "react";
import Button from "src/components/Button";
import Modal from "src/components/Modal/Modal";
import useLoader from "src/hooks/useLoader";
import { sendAllReminder } from "src/network/interview";

const RemindAllButton = ({
  job_id,
  onRemind,
  disabled = false
}: {
  job_id?: number;
  disabled: boolean;
  onRemind: () => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const remindAll = async () => {
    if (!job_id) return;
    await sendAllReminder({ job_id });
    onRemind();
    setOpen(false);
  };
  const { ldng, loading } = useLoader(remindAll, { successMsg: "All reminders were sent" });

  return (
    <div>
      <Button disabled={disabled} onClick={() => setOpen(true)} shapeVariant={2}>
        Remind everyone
      </Button>
      <Modal className="flex flex-col !w-[500px] gap-6 text-center" open={open} onChange={setOpen}>
        <p className="font-poppins text-xl font-semibold">Send Reminder To Everyone</p>
        <p className="font-[500] text-base leading-[32px] text-[#8A8A8A]">
          Email will be sent to all interview invitees as a gentle reminder to schedule their
          interviews at their earliest convenience.
        </p>
        <div className="flex mx-auto gap-6">
          <Button onClick={() => setOpen(false)} shapeVariant={2} variant="white_blue">
            Cancel
          </Button>
          <Button
            className="!w-[212px] !h-[56px]"
            loading={loading}
            disabled={!job_id}
            onClick={ldng}
            shapeVariant={2}
          >
            Send reminder to all
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default RemindAllButton;
